import { useContext } from "react";
import { LoadingBackdropOverlayContext } from "./LoadingBackdropOverlayProvider";

export const useLoadingBackdropOverlayContext = () => useContext(LoadingBackdropOverlayContext);

export default useLoadingBackdropOverlayContext;
